import $ from 'jquery';


export default function umeReadyAccordions(){
    // Set ID to each accordion
    $('.ume-accordion-wrapper').each(function (index) {
        $(this).attr('id', 'accordion-' + index);
    });

// Set data-parent ID to each accordion card
    $('.ume-accordion-wrapper [data-parent]').each(function () {
        let get_parent_id = $(this).parent().parent().attr('id');

        $(this).attr('data-parent', '#' + get_parent_id);
    });

// Add minus icon for collapse element which is open by default
    $('.collapse.show').each(function () {
        $(this).prev('.card-header').find('.fa').addClass('icon-accordion-minus').removeClass('icon-accordion-plus');
    });

// Toggle plus minus icon on show hide of collapse element
    $('.collapse').on('show.bs.collapse', function () {
        $(this).prev('.card-header').find('.fa').removeClass('icon-accordion-plus').addClass('icon-accordion-minus');
    }).on('hide.bs.collapse', function () {
        $(this).prev('.card-header').find('.fa').removeClass('icon-accordion-minus').addClass('icon-accordion-plus');
    });
}


